export default "__VITE_ASSET__BzYstuN4__"